import React from 'react';
import moment from 'moment';
import PPMobileCardView from '../../../components/PPMobileCardView';

const MovementMobile = ({ data, onEdit, onDelete }) => {
    const rows = [
        { label: 'Date', value: moment(data.date).format("DD-MM-YYYY"), inHeader: true, hideLabel: true },
        { label: 'Material Type', value: data.materialType },
        { label: 'Quantity', value: data.quantity },
        { label: 'Cost', value: data.cost != null ? data.cost.toFixed(2) : '' },
        { label: 'Shed/Storage', value: data.shedName, fullWidth: true },
    ];

    const menuItems = [
        { label: 'Edit', onClick: onEdit },
        { label: 'Delete', onClick: onDelete },
    ];

    return (
        <PPMobileCardView
            title={data.materialName}
            id={data.id}
            rows={rows}
            menuItems={menuItems}
        />
    );
};

export default MovementMobile;
